import { Grid } from '@material-ui/core';
import useWellbore from 'features/wells/hooks/useWellbore';
import LogFilesTable from 'features/wells/corrosion/components/LogFilesTable';
import { connect } from 'react-redux';
import {
  loadCorrosionLogs,
  deleteCorrosionLog,
  loadCorrosionLogFile,
} from 'features/wells/corrosion/helpers/corrosionlogs.actions';

import { selectCorrosionLogsList } from 'features/wells/corrosion/helpers/corrosionlogs.selectors';
import { useEffect } from 'react';
import { useState } from 'react';

const LogFilesContainer = ({
  wellboreId,
  dispatchLoadCorrosionLogs,
  corrosionLogs,
  dispatchDeleteCorosionLog,
  dispatchLoadCorrosionLog,
}) => {
  const { wellbore } = useWellbore(wellboreId);

  const [deleteFlag, setDeleteFlag] = useState(false);

  useEffect(() => {
    if (wellbore.get('externalWellboreExternalId')) {
      dispatchLoadCorrosionLogs(wellbore.get('externalWellboreExternalId'));
    }
  }, [wellbore, deleteFlag, dispatchLoadCorrosionLogs]);

  return (
    <>
      <Grid container item>
        <Grid item xs={10}>
          <LogFilesTable
            corrosionLogs={corrosionLogs}
            downloadLog={(logId) => dispatchLoadCorrosionLog(logId)}
            deleteLog={(logId) => {
              dispatchDeleteCorosionLog(logId, setDeleteFlag, deleteFlag);
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default connect(
  (state) => ({
    corrosionLogs: selectCorrosionLogsList(state),
  }),
  {
    dispatchLoadCorrosionLogs: loadCorrosionLogs,
    dispatchDeleteCorosionLog: deleteCorrosionLog,
    dispatchLoadCorrosionLog: loadCorrosionLogFile,
  },
)(LogFilesContainer);
